<template>
	<div class="dlogD">
		<div class="closeDlog" @click="closeDlog">
			<img src="../../../../public/icon/005.png"/>
		</div>
		<div class="imgD">
			<div class="imgD_left">
				<img :src="bigImgUrl" />
			</div>
			<div class="imgD_right">
				<div class="photoTime">
					<div class="uuname">{{pageParams.nickname}} <span style="color: #666;font-size: 12px;">上传</span></div>
					<div class="uutime">{{pageParams.create_time}}</div>
				</div>
				<div class="photoTime" style="margin-top: 20px;">
					<div class="uuname">{{pageParams.remark}}</div>
				</div>
				<div class="moreImg">
					<div class="moreImg_item" v-for="im in imgUrlArr">
						<img v-if="im!=''" @click="seeImg(im)" :src="im"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import baseConst from '../../../assets/js/baseConst.js' //注意路
	export default{
		props:['pageParams'],
		data(){
			return{
				bigImgUrl:'',
				imgUrlArr:[],
			}
		},
		created:function(){
			let _this = this;
			//console.log(_this.pageParams)
			let imgUrlArr = _this.pageParams.works.split('|');
			for (let i = 0; i < imgUrlArr.length; i++) {
				//imgUrlArr[i] = baseConst.IMG_API + imgUrlArr[i];
				if (imgUrlArr[i]!='') {
					_this.imgUrlArr.push(baseConst.IMG_API + imgUrlArr[i])
				}
				
			}
			//_this.imgUrlArr = imgUrlArr;
			_this.bigImgUrl =_this.imgUrlArr[0];
		},
		methods:{
			/**  * -----选择图片 查看  
			 * @version 1.0  * @author 您的大名 2019年12月3日  * */
			seeImg(url){
				let _this = this;
				_this.bigImgUrl = url;
			},
			/**  * ----- 关闭dailog 
			 * @version 1.0  * @author 您的大名 2019年12月3日  * */
			closeDlog(){
				let _this = this;
				_this.$emit('parentMethod','works_info');
			},
		}
	}
</script>

<style scoped>
	.imgD {
		width: 70%;
		min-height: 100px;
		margin: auto;
		display: flex;
		flex-direction: row;
	}
	
	.imgD .imgD_left {
		width: 70%;
		box-shadow: 0 0 8px #ccc;
		padding: 15px;
		background-color: #fff;
	}
	
	.imgD .imgD_left img {
		width: 100%;
	}
	
	.imgD .imgD_right {
		flex: 1;
		margin-left: 20px;
	}
	
	.photoTime {
		background-color: #fff;
		box-shadow: 0 0 8px #ccc;
		padding: 5px;
	}
	
	.uutime {
		padding: 5px 0;
		color: #ccc;
		margin-top: 8px;
	}
	.moreImg{
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		box-shadow: 0 0 8px #ccc;
		margin-top: 10px;
	}
	.moreImg .moreImg_item{
		width: 50%;
		padding: 5px;
		box-sizing: border-box;
	}
	.moreImg .moreImg_item img{
		width: 100%;
		cursor: pointer;
	}
	.moreImg .moreImg_item img:hover{
		transform: scale(1.02);
	}
	.closeDlog{
		width: 30px;
		position: absolute;
		right: 30px;
		cursor: pointer;
	}
	.closeDlog img{
		width: 100%;
	}
</style>